module.exports = __webpack_public_path__ + "img/file_video.26324f84.png";